import shuffle from 'shuffle-array';

async function loadWordInfo(db, taskId, uid, word) {
  const stats = await db
    .collection('user')
    .doc(uid)
    .collection('wordstats')
    .doc(word)
    .get()
  const reports = await db
    .collection('task')
    .doc(taskId)
    .collection('wordreports')
    .doc(word)
    .get()
  const wordInfo = {
    issues: 0,
    last: Math.round(Math.random()),
    next: undefined,
    lasttime: 0,
    rand: Math.random(),
  }
  if (reports.exists) {
    wordInfo.issues = reports.data().issues || 0
  }
  if (stats.exists) {
    wordInfo.last = stats.data().last || wordInfo.last
    wordInfo.lasttime = stats.data().lasttime || 0
  }
  if (wordInfo.next === undefined) {
    wordInfo.next = 0.5 + (wordInfo.last - 0.5) * 0.5
  }
  return wordInfo
}

async function updateWordStats(db, userId, answered) {
  const docRef = db
    .collection('user')
    .doc(userId)
    .collection('wordstats')
    .doc(answered.text)
  const current = await docRef.get()
  if (current.exists) {
    await docRef.update(answered)
    return
  }
  await docRef.set(answered)
}

function compareWordInfo(w1, w2) {
  if (w1.issues < w2.issues) {
    return -1
  }
  if (w1.issues > w2.issues) {
    return 1
  }
  if (w1.lasttime < w2.lasttime) {
    return -1
  }
  if (w1.lasttime > w2.lasttime) {
    return 1
  }
  return w1.rand - w2.rand
}

export async function updateQuizScore(db, userId, allAnswers) {
  console.log('QuizScore', allAnswers)
  if (!allAnswers.events) {
    return null
  }
  const answered = []
  allAnswers.events
    .filter((event) => event.action === 'answer')
    .forEach((event) => {
      answered.push({
        text: event.question.text.toLowerCase(),
        last: event.answerIndex === event.question.answerIndex ? 1 : 0,
        lasttime: event.time,
      })
    })
  await Promise.all(answered.map((a) => updateWordStats(db, userId, a)))
  return null
}

export async function updateTaskRefQuizAccess(db, userId, taskId, currentTime) {
  const taskRef = db
    .collection('user')
    .doc(userId)
    .collection('taskref')
    .doc(taskId)
  const oldTask = await taskRef.get()
  if (!oldTask.exists) {
    return
  }
  await taskRef.update({
    quizAccessed: currentTime.getTime(),
  })
}

export async function arrangeQuiz(db, taskId, uid, quiz) {
  console.log('Quiz', quiz.length)
  const words = []
  quiz.forEach((q) => {
    const wtext = q.text.toLowerCase()
    if (words.includes(wtext)) {
      return
    }
    words.push(wtext)
  })
  const wordInfo = await Promise.all(words.map((word) => loadWordInfo(db, taskId, uid, word)))
  const wordInfoMap = {}
  words.forEach((word, index) => {
    wordInfoMap[word] = wordInfo[index]
  })
  const newQuiz = quiz.map((q) => q)
  newQuiz.sort((q1, q2) => compareWordInfo(
    wordInfoMap[q1.text.toLowerCase()],
    wordInfoMap[q2.text.toLowerCase()]
  ))
  console.log('Quiz - 1', newQuiz, wordInfoMap)

  const corrected = []
  const incorrected = []
  newQuiz.forEach((q) => {
    if (wordInfoMap[q.text.toLowerCase()].next >= 0.75) {
      corrected.push(q)
    } else {
      incorrected.push(q)
    }
  })
  console.log('Quiz - 2', corrected.map((v) => v), incorrected.map((v) => v))
  let nextQuiz = []
  const CORRECT_TASKS = 4
  const INCORRECT_TASKS = 1
  while(corrected.length >= CORRECT_TASKS && incorrected.length >= INCORRECT_TASKS) {
    const candidates = []
    for (let i = 0; i < CORRECT_TASKS; i ++) {
      candidates.push(corrected.shift())
    }
    for (let i = 0; i < INCORRECT_TASKS; i ++) {
      candidates.push(incorrected.shift())
    }
    shuffle(candidates)
    nextQuiz = nextQuiz.concat(candidates)
  }
  const candidates_ = corrected.concat(incorrected)
  while(candidates_.length >= CORRECT_TASKS + INCORRECT_TASKS) {
    const candidates = []
    for (let i = 0; i < CORRECT_TASKS + INCORRECT_TASKS; i ++) {
      candidates.push(candidates_.shift())
    }
    shuffle(candidates)
    nextQuiz = nextQuiz.concat(candidates)
  }
  if (candidates_.length > 0) {
    shuffle(candidates_)
    nextQuiz = nextQuiz.concat(candidates_)
  }
  console.log('Quiz - 3', nextQuiz)
  return nextQuiz
}
